module.exports = __webpack_public_path__ + "static/media/S1_00001.f883b71d.jpg";